/**
 * Created by ricardocabret on 8/8/16.
 */
angular.module('eStories.seeAll', [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.seeAll', {
                url: 'section/:sectionName?pageNumber&genreId&&subGenreId&sortField&languageId&duration&abridged&onlyForFree&onlyForCredit&onlyOnSale',
                views: {
                    'mainView@': {
                        templateUrl: 'home/seeAll/seeAll.tmpl.html',
                        controller: 'SeeAllCtrl',
                        controllerAs: 'seeAllCtrl'
                    }
                }
            });
    }])

    .controller('SeeAllCtrl', [
        '$state',
        '$stateParams',
        'CatalogModel',
        'PagingModel',
        '$rootScope',
        '$window',
        '$scope',
        'SortFilterFactory',
        '$filter',
        '$location',
        'SeoModel',
        'GA',
        function ($state, $stateParams, CatalogModel, PagingModel, $rootScope, $window, $scope, SortFilterFactory,
                  $filter, $location, SeoModel, GA) {

            let seeAllCtrl = this;

            GA.trackPageView($location.path());

            SeoModel.applyMetaTags($state.current.name, $stateParams.sectionName);

            seeAllCtrl.listView = SortFilterFactory.listViewMode['eStories.navbars.seeAll'].mode;

            seeAllCtrl.currentState = $state.current.name;

            seeAllCtrl.shouldHideSortAndFilter = function () {
                // anything on this list will not have sort & filter on the see all page
                return CatalogModel.isPageName('great_first_listens') ||
                    CatalogModel.isPageName('great_movie_tie_ins') ||
                    CatalogModel.isPageName('pride_month') ||
                    CatalogModel.isPageName('great_summer_listens') ||
                    CatalogModel.isPageName('haunting_listens') ||
                    CatalogModel.isPageName('books_of_the_year_2018') ||
                    CatalogModel.isPageName('chilling_listens') ||
                    CatalogModel.isPageName('beyond_bracket_2019') ||
                    CatalogModel.isPageName('national_book_award_longlist_2018') ||
                    CatalogModel.isPageName('holiday_season_2018') ||
                    CatalogModel.isPageName('valentines_day') ||
                    CatalogModel.isPageName('audie_winners') ||
                    CatalogModel.isPageName('personalized_recommendations') ||
                    CatalogModel.isPageName('kid_control') ||
                    CatalogModel.isPageName('summer_listens') ||
                    CatalogModel.isPageName('off_the_beaten_path') ||
                    CatalogModel.isPageNameLike('on_sale') ||
                    CatalogModel.isPageName('trippin') ||
                    CatalogModel.isPageName('me_time') ||
                    CatalogModel.isPageName('sizzlin_hot') ||
                    CatalogModel.isPageName('oprah_says_so') ||
                    CatalogModel.isPageName('short_and_sweet') ||
                    CatalogModel.isPageName('ursula_k_le_guin') ||
                    CatalogModel.isPageNameLike('best_audiobooks_of') ||
                    CatalogModel.isPageNameLike('back_to_school');
            };

            PagingModel.updatePageNumber(seeAllCtrl.currentState, parseInt($stateParams.pageNumber) || 1);

            if (PagingModel.pagingData[seeAllCtrl.currentState].totalCount == null) {
                SortFilterFactory.resetFilterObj();
            }

            $rootScope.$on("windowResized", function (event) {
                if ($window.innerWidth < 650) {
                    seeAllCtrl.listView = false
                } else {
                    seeAllCtrl.listView = SortFilterFactory.listViewMode['eStories.navbars.seeAll'].mode;
                }
            });

            $rootScope.$on('changeGridView', function (event, toggle) {
                seeAllCtrl.listView = toggle;
                SortFilterFactory.listViewMode[seeAllCtrl.currentState].mode = toggle;
                safeApply($scope);
            });

            const defaultSorting = function (location) {
                if (CatalogModel.isPageName('great_first_listens') ||
                    CatalogModel.isPageName('great_movie_tie_ins') ||
                    CatalogModel.isPageName('pride_month') ||
                    CatalogModel.isPageName('best_audiobooks_of_2017')) {
                    seeAllCtrl.descendingOrder = false;
                    return null;
                }
                if (CatalogModel.isPageName('new_releases')) {
                    return 'release_date';
                }
                if (CatalogModel.isPageNameLike('on_sale')) {
                    return 'most_popular';
                }
                return 'most_popular_this_week';
            };

            var globalFilterObj = SortFilterFactory.filterObj;
            seeAllCtrl.descendingOrder = true;
            globalFilterObj.languageId = $stateParams.languageId != null ? $stateParams.languageId : globalFilterObj.languageId;
            globalFilterObj.genreId = $stateParams.genreId != null ? parseInt($stateParams.genreId) : globalFilterObj.genreId;
            globalFilterObj.subGenreId = $stateParams.subGenreId != null ? parseInt($stateParams.subGenreId) : globalFilterObj.subGenreId;
            globalFilterObj.sortField = $stateParams.sortField != null ? $stateParams.sortField : defaultSorting($location.path());
            globalFilterObj.duration = $stateParams.duration || globalFilterObj.duration;
            globalFilterObj.abridged = $stateParams.abridged || globalFilterObj.abridged;
            globalFilterObj.onlyForFree = $stateParams.onlyForFree || globalFilterObj.onlyForFree;
            globalFilterObj.onlyForCredit = $stateParams.onlyForCredit || globalFilterObj.onlyForCredit;
            globalFilterObj.onlyOnSale = $stateParams.onlyOnSale || globalFilterObj.onlyOnSale;


            /*Request Obj*/
            seeAllCtrl.sortField = globalFilterObj.sortField != null ? globalFilterObj.sortField.toUpperCase() : null;

            seeAllCtrl.browseFilter = {
                abridged: globalFilterObj.abridged != null ? JSON.parse(globalFilterObj.abridged) : null,
                onlyForFree: globalFilterObj.onlyForFree != null ? JSON.parse(globalFilterObj.onlyForFree) : null,
                onlyForCredit: globalFilterObj.onlyForCredit != null ? JSON.parse(globalFilterObj.onlyForCredit) : null,
                onlyOnSale: globalFilterObj.onlyOnSale != null ? JSON.parse(globalFilterObj.onlyOnSale) : null
            };

            seeAllCtrl.browseFilter.genreIdList = globalFilterObj.genreId == null ? null : [globalFilterObj.genreId];
            if (globalFilterObj.subGenreId != null) {
                seeAllCtrl.brow=seFilter.genreIdList = [globalFilterObj.subGenreId];
            }

            if (globalFilterObj.languageId != null) {
                seeAllCtrl.browseFilter.languageIdList = [];
                const languageArray = globalFilterObj.languageId.split(',');
                for (let i = 0; i < languageArray.length; i++) {
                    seeAllCtrl.browseFilter.languageIdList.push(parseInt(languageArray[i]));
                }
            }

            if (globalFilterObj.duration != null) {
                seeAllCtrl.browseFilter.durationFilterList = [];
                const durationArray = globalFilterObj.duration.split(',');
                for (let i = 0; i < durationArray.length; i++) {

                    let c = durationArray[i];
                    seeAllCtrl.browseFilter.durationFilterList.push({
                        minHours: c.match(/.+?(?=-)/) != null ? parseInt(c.match(/.+?(?=-)/)) : null,
                        maxHours: c.match(/[^-]+$/) != null ? parseInt(c.match(/[^-]+$/)) : null
                    });
                }
            }

            //Check sortField alphabetical descending status
            if (globalFilterObj.sortField != null) {
                if (globalFilterObj.sortField === 'alphabetically') {
                    seeAllCtrl.descendingOrder = false;
                } else if (globalFilterObj.sortField === 'alphabetically_descending') {
                    seeAllCtrl.sortField = 'ALPHABETICALLY';
                }
            }


            // Grid View or List View when loading
            if (seeAllCtrl.currentState !== 'eStories.navbars.seeAll') {
                seeAllCtrl.listView = $window.innerWidth < 650 ? false : SortFilterFactory.listViewMode[seeAllCtrl.currentState].mode;
            } else {
                seeAllCtrl.listView = $window.innerWidth < 650 ? false : SortFilterFactory.listViewMode[seeAllCtrl.currentState].mode;
            }

            /*End of request obj*/


            $rootScope.$on('changeGridView', function (event, toggle) {
                seeAllCtrl.listView = toggle;
                SortFilterFactory.listViewMode['eStories.navbars.seeAll'].mode = toggle;
                safeApply($scope);
            });

            seeAllCtrl.setHeaderTitle = function (sectionName) {
                switch (sectionName) {
                    case "NEW_RELEASES":
                        seeAllCtrl.headerTitle = 'new releases';
                        break;
                    case "BEST_SELLERS":
                        seeAllCtrl.headerTitle = 'bestsellers';
                        break;
                    case "NEW_YORK_TIMES_BEST_SELLERS":
                        seeAllCtrl.headerTitle = 'nyt bestsellers';
                        break;
                    case "EDITORS_PICKS":
//                      below is because the title at the top of the editors' picks page was showing up with a drifting apostrophe
                        seeAllCtrl.headerTitle = "Editor<span class='driftingApostrophe' style='letter-spacing: -19px;'>s</span>' Picks"
                        break;
                    case "SIZZLIN_HOT":
//                      below is because the title at the top of the editors' picks page was showing up with a drifting apostrophe
                        seeAllCtrl.headerTitle = "sizzli<span class='driftingApostrophe' style='letter-spacing: -19px;'>n</span>' hot"
                        break;
                    case "BACK_TO_SCHOOL_MIDDLE_AND_HIGH_SCHOOL":
                        seeAllCtrl.headerTitle = 'MIDDLE AND HIGH SCHOOL';
                        break;
                    case "BACK_TO_SCHOOL_CONTINUED_EDUCATION":
                        seeAllCtrl.headerTitle = 'CONTINUED EDUCATION';
                        break;
                    case "BACK_TO_SCHOOL_COLLEGE":
                        seeAllCtrl.headerTitle = 'COLLEGE';
                        break;
                    case "Remembering Ursula K Le Guin and her work":
                        seeAllCtrl.headerTitle = 'Ursula K Le Guin';
                        break;
                    case "Valentine's Day":
                        seeAllCtrl.headerTitle = "Valentin<span class='driftingApostrophe' style='letter-spacing: -19px;'>e</span>'s Day";
                        break;
                    case "Spring Sale":
                    case "ON_SALE":
                    case "Audie Awards Winners":
                    case "HAUNTING_LISTENS":
                    case "2018 National Book Award Longlist":
                    case "Beyond Your Bracket":
                    case "CHILLING_LISTENS":
                    case "BEST_AUDIOBOOKS_OF_2017":
                        seeAllCtrl.headerTitle = '';
                        break;
                    default:
                        seeAllCtrl.headerTitle = sectionName.replace(/_/g, ' ');
                }
            };

            seeAllCtrl.getMobileHeaderBackgroundClass = function () {
                if (CatalogModel.isPageNameLike('middle_and_high_school')) {
                    return 'middle_and_high_school';
                }
                if (CatalogModel.isPageNameLike('continued_education')) {
                    return 'continued_education';
                }
                if (CatalogModel.isPageNameLike('college')) {
                    return 'college';
                }
            };

            seeAllCtrl.getHeaderBackgroundImage = function () {
                if (CatalogModel.isPageNameLike('new_york')) {
                    return getCoverStyleBackground('../assets/img/seeAll/nytBestsellers.png');
                }
                if (CatalogModel.isPageNameLike('on_sale')) {
                    // var now = new Date();
                    // var switchDate = new Date(Date.UTC(2017,11,26,5,0));
                    // if (now > switchDate) {
                    //     return getCoverStyleBackground('../assets/img/seeAll/NEW_YEAR_2018.jpg');
                    // } else {
                    return getCoverStyleBackground('../assets/img/seeAll/springSale.jpg');
                    // }
                }
                if (CatalogModel.isPageName('free_books')) {
                    return getCoverStyleBackground('../assets/img/seeAll/freeAudiobooks.png');
                }
                if (CatalogModel.isPageName('best_audiobooks_of_2017')) {
                    return getCoverStyleBackground('../assets/img/seeAll/BEST_AUDIOBOOKS_OF_2017.jpg');
                }
                if (CatalogModel.isPageName('beyond_bracket_2019')) {
                    return getCoverStyleBackground('../assets/img/seeAll/BEYOND_BRACKET_2019.jpg');
                }
                if (CatalogModel.isPageName('kid_control')) {
                    return getCoverStyleBackground('../assets/img/seeAll/kidControl.jpg');
                }
                if (CatalogModel.isPageName('off_the_beaten_path')) {
                    return getCoverStyleBackground('../assets/img/seeAll/offPath.jpg');
                }
                if (CatalogModel.isPageName('trippin')) {
                    return getCoverStyleBackground('../assets/img/seeAll/trippin.jpg');
                }
                if (CatalogModel.isPageName('me_time')) {
                    return getCoverStyleBackground('../assets/img/seeAll/meTime.jpg');
                }
                if (CatalogModel.isPageName('oprah_says_so')) {
                    return getCoverStyleBackground('../assets/img/seeAll/oprah.jpg');
                }
                if (CatalogModel.isPageName('short_and_sweet')) {
                    return getCoverStyleBackground('../assets/img/seeAll/shortNSweet.jpg');
                }
                if (CatalogModel.isPageName('summer_listens')) {
                    return getCoverStyleBackground('../assets/img/seeAll/summer_listens.png');
                }
                if (CatalogModel.isPageName('haunting_listens')) {
                    return getCoverStyleBackground('../assets/img/seeAll/haunting_listens.jpg');
                }
                if (CatalogModel.isPageName('national_book_award_longlist_2018')) {
                    return getCoverStyleBackground('../assets/img/seeAll/NBA_LONGLIST_2018.jpg');
                }
                if (CatalogModel.isPageName('valentines_day')) {
                    return getCoverStyleBackground('../assets/img/seeAll/valentines.jpg');
                }
                if (CatalogModel.isPageName('audie_winners')) {
                    return getCoverStyleBackground('../assets/img/seeAll/AUDIE.jpg');
                }
                if (CatalogModel.isPageNameLike('middle_and_high_school')) {
                    return getCoverStyleBackground('../assets/img/theme/middleAndHighSchool.jpg');
                }
                if (CatalogModel.isPageNameLike('continued_education')) {
                    return getCoverStyleBackground('../assets/img/theme/conEd.jpg');
                }
                if (CatalogModel.isPageNameLike('college')) {
                    return getCoverStyleBackground('../assets/img/theme/college.jpg');
                }
                if (CatalogModel.isPageName('new_releases') ||
                    CatalogModel.isPageName('best_sellers') ||
                    CatalogModel.isPageName('editors_picks')) {
                    return getCoverStyleBackground('../assets/img/carousel/static_artboard.jpg');
                }
            };

            seeAllCtrl.getSectionItemList = async (browseFilterObj, isMobile) => {
                const response = await CatalogModel.getSectionItemList(browseFilterObj);
                if (response && response.responseStatus === 'SUCCESS') {
                    if (seeAllCtrl.askForTotalCount) {
                        PagingModel.updateResultsData(seeAllCtrl.currentState, response.totalCount);
                    } else {
                        PagingModel.updateResultsData(seeAllCtrl.currentState, null);
                    }
                    if (isMobile && PagingModel.pagingData[seeAllCtrl.currentState].pageNumber > 1) {
                        seeAllCtrl.seeAllList = seeAllCtrl.seeAllList.concat(response.audiobookList)
                    } else {
                        if (seeAllCtrl.seeAllList) {
                            seeAllCtrl.seeAllList = seeAllCtrl.seeAllList.concat(response.sectionItemList)
                        } else {
                            seeAllCtrl.seeAllList = response.sectionItemList;
                        }
                    }
                    const totalCount = response.totalCount;
                    // PagingModel.updateResultsData('eStories.navbars.seeAll', response.totalCount);
                    $rootScope.$broadcast('setTotalCount', totalCount);
                    seeAllCtrl.callInProgress = false;
                }
            };

            //Parent function
            seeAllCtrl.getPage = async (pageNumber, callbackFunc) => {
                seeAllCtrl.callInProgress = true;
                seeAllCtrl.askForTotalCount = true;


                seeAllCtrl.browseFilter.pagination = PagingModel.preparePagination(
                    pageNumber,
                    null,
                    seeAllCtrl.descendingOrder,
                    seeAllCtrl.askForTotalCount,
                    seeAllCtrl.sortField
                );

                seeAllCtrl.browseFilter.browseList = true;
                seeAllCtrl.browseFilter.sectionName = $stateParams.sectionName.toUpperCase();
                seeAllCtrl.browseFilter.sectionId = null;

                const res = await CatalogModel.getSectionByName($stateParams.sectionName.toUpperCase());
                if (res && res.responseStatus === 'SUCCESS') {
                    seeAllCtrl.setHeaderTitle(res.section.title['en']);
                    seeAllCtrl.browseFilter.sectionId = res.section.id;
                    seeAllCtrl.getSectionItemList(seeAllCtrl.browseFilter)
                }

                if (callbackFunc) callbackFunc();
            };

            /*Initial Call*/

            seeAllCtrl.getPage(PagingModel.pagingData[seeAllCtrl.currentState].pageNumber).then();

            function constructGetParamsObj(pageNumber, filterObj) {
                //Save pagingData currentPage globally

                PagingModel.pagingData.currentPage = pageNumber;

                for (let param in globalFilterObj) {
                    if (globalFilterObj[param] == null) {
                        delete globalFilterObj[param];
                    }
                }
                globalFilterObj.pageNumber = pageNumber;

                if (filterObj && filterObj.obj != null) {
                    if (filterObj.filterType === 'genreId') {
                        delete globalFilterObj.subGenreId;
                    }
                    globalFilterObj[filterObj.filterType] = filterObj.obj;
                }
                return globalFilterObj
            }

            /*Listener to paging component*/
            $scope.$on('getPage', function (event, pageNumber) {
                if (seeAllCtrl.callInProgress) return;
                var filterObj = constructGetParamsObj(pageNumber);
                $location.search(filterObj);
            });

            $scope.$on('loadMore', function (event, pageNumber) {
                PagingModel.pagingData[seeAllCtrl.currentState].pageNumber = pageNumber;
                seeAllCtrl.getPage(pageNumber, null, true);
            });

            //Listener to sortFilter Component
            $scope.$on('updateFilter', function (event, filterObj) {
                //Todo: Only reset counts when filtering , not sorting!!!!
                PagingModel.pagingData[seeAllCtrl.currentState].totalCount = null;
                PagingModel.pagingData[seeAllCtrl.currentState].totalPageCount = null;
                filterObj = constructGetParamsObj(null, filterObj);
                $location.search(filterObj);
            });

        }]);
